module.exports = __webpack_public_path__ + "static/media/hexagon-default.65b86ea8.svg";